import { all } from 'redux-saga/effects';
import loginSaga from './login.saga';
import forgotPasswordSaga from './forgot_password.saga';
import resetPasswordSaga from './reset_password.saga';
import createAccountSaga from './create_new_account.saga';
import verifyAccountSaga from './verify_account.saga';
import logoutSaga from './logout.saga';
import getInitialDataSaga from './get_initial_data.saga';

export default function* userAuthRootSaga() {
    yield all([
        loginSaga(),
        getInitialDataSaga(),
        createAccountSaga(),
        forgotPasswordSaga(),
        resetPasswordSaga(),
        verifyAccountSaga(),
        logoutSaga(),
    ]);
}



// WEBPACK FOOTER //
// ./src/modules/App/redux/sagas/auth_root.saga.js